export const POLICY_TOPICS = [
  { id: "climate-change", name: "Climate change (e.g., reducing emissions or energy use)" },
  { id: "pollution", name: "Pollution" },
  { id: "water-marine", name: "Water use (e.g., managing or reducing water use)" },
  { id: "biodiversity", name: "Biodiversity (protecting land, nature, and wildlife)" },
  { id: "circular-economy", name: "Circular Economy (reducing waste and reusing materials)" },
  { id: "own-workforce", name: "Own Workforce" },
  { id: "value-chain-workers", name: "Suppliers and workers (working conditions in your supply chain)" },
  { id: "affected-communities", name: "Local communities (impact on people near your operations)" },
  { id: "consumers", name: "Consumers and end-users" },
  { id: "business-conduct", name: "Business conduct (e.g., ethics, anti-corruption, or responsible behaviour)" },
];
